import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Gestisce il ritorno dall'OAuth Google (Emergent). Legge il session_id dal
// fragment dell'URL, lo scambia lato backend (che imposta il cookie httpOnly) e
// reindirizza in base al ruolo.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    // Pulisce subito il fragment dall'URL (il session_id è monouso)
    try { window.history.replaceState(null, "", window.location.pathname + window.location.search); } catch (e) {}

    if (!sessionId) { navigate("/login", { replace: true }); return; }

    (async () => {
      try {
        const user = await loginWithGoogleSession(sessionId);
        toast.success("Accesso effettuato");
        navigate(user?.role === "client" ? "/portale" : "/", { replace: true });
      } catch (e) {
        setError(true);
        toast.error(e?.response?.data?.detail || "Accesso con Google non riuscito");
        setTimeout(() => navigate("/login", { replace: true }), 1600);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      {!error ? (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-[hsl(var(--hi-gold))]" />
          <p className="text-sm text-muted-foreground">Accesso in corso…</p>
        </>
      ) : (
        <p className="text-sm text-destructive">Accesso non riuscito. Ti riporto al login…</p>
      )}
    </div>
  );
}
